import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

//import { ReactGrid } from "@idlewee/reactgrid";
import { ReactGrid } from "@utils/reactgrid";
import "@silevis/reactgrid/styles.css";
// -------------------------------------------------------

const simpleHandleContextMenu = (
  selectedRowIds,
  selectedColIds,
  selectionMode,
  menuOptions,
  selectedRanges
) => {
  menuOptions = menuOptions.map((d) => {
    if( d.id == 'copy' ) d.label = <span><i className="material-icons">content_copy</i>コピー</span>;
    if( d.id == 'cut' ) d.label = <span><i className="material-icons">content_cut</i>カット</span>;
    if( d.id == 'paste' ) d.label = <span><i className="material-icons">content_paste</i>貼り付け</span>;
    return d;
  });
  return menuOptions;
}

class Grid extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      rows       : [],
      columns    : [],
      is_loading : false,
    };
  }
  // -------------------------------------------------------
  
  componentDidMount() {
    let columns = [{ columnId: 'no', width: 50 }];
    let parent_columns = this.props.parent_columns;
    
    let rowKey = 1;
    
    // Excelカラム
    let rowTop = { rowId: 'excel_row', cells: [{ type: 'header', text: '', className: 'main-header main-left' }] }
    
    // 親カラム
    let rowParent;
    let parentColumnList = [];
    if( parent_columns != undefined ){
      rowParent = { rowId: 'header_parent', cells: [{ type: 'header', text: String(rowKey), className: 'main-left' }] }
      rowKey++;
      
      parent_columns.map((d) => {
        parentColumnList.push(d.id);
        
        for( let i = 0; i < d.colspan; i++ ){
          if( i == 0 ){
            rowParent.cells.push({ type: 'header', text: d.name, colspan: d.colspan, className: 'parent-header' });
          } else {
            rowParent.cells.push({ type: 'header', text: '' });
          }
        }
      });
    }
    
    // ヘッダー
    let rowHeader = { rowId: 'header', cells: [{ type: 'header', text: String(rowKey), className: 'main-left' }] }
    rowKey++;
    
    this.props.columns.map((d, key) => {
      if( parentColumnList.length > 0 && parentColumnList.indexOf(d.parent) == -1 ) return; // 親データが存在しない場合はスキップ
      
      rowTop.cells.push({ type: 'header', text: Utils.getExcelRowString((key + 1)), className: 'main-header' });
      rowHeader.cells.push({ type: 'header', text: d.name, className: 'column-header' });
      
      columns.push({ columnId: d.id, width: d.width, type: d.type, resizable: true });
    });
    
    let rows = [rowTop, rowHeader];
    if( rowParent != undefined ) rows = [rowTop, rowParent, rowHeader];
    
    // ボディリスト
    this.props.items.map((d, key) => {
      rows.push(this.createColumn.bind(this)((key + rowKey), d));
    });
    
    let create_count = (rows.length - rowKey);
    if( this.props.defaultRowCount != undefined ){
      let no = rows.length;
      if( this.props.items.length == 0 ) no--;
      
      for( let i = 0; i < (this.props.defaultRowCount - create_count); i++ ){
        no++;
        rows.push(this.createColumn.bind(this)(no, {}));
      }
    }
    
    this.setState({ rows: rows, columns: columns });
  }
  // -------------------------------------------------------
  
  createColumn(rowId, data) {
    let parentColumnList = [];
    if( this.props.parent_columns != undefined ) this.props.parent_columns.map((d) => { parentColumnList.push(d.id); });
    
    let disable_columns = this.props.disable_columns;
    if( disable_columns == undefined ) disable_columns = [];
    
    // カラムリストの生成
    let rowBody = { rowId: rowId, cells: [{ type: 'header', text: String(rowId), className: 'main-left' }] };
    this.props.columns.map((c, ckey) => {
      if( parentColumnList.length > 0 && parentColumnList.indexOf(c.parent) == -1 ) return; // 親データが存在しない場合はスキップ
      
      let type = (c.type == undefined) ? 'text' : c.type;
      let editable = (disable_columns.indexOf(c.id) >= 0);
      
      if( type == 'dropdown' ){
        let text = (data[c.id] == undefined) ? '' : data[c.id];
        let values = [];
        c.values.map((v, vkey) => { values.push({ label: v, value: v }) });
        
        rowBody.cells.push({ type: type, text: text, selectedValue: text, values: values, className: c.className, nonEditable: editable });
      } else if( type == 'number' ){
        let text = (data[c.id] == undefined) ? '' : data[c.id];
        rowBody.cells.push({ type: type, text: text, value: text, hideZero: false, className: c.className, nonEditable: editable });
      } else if( type == 'date' ) {
        let text = (data[c.id] == undefined) ? '' : data[c.id];
        rowBody.cells.push({ type: type, text: text, value: text, date: new Date(text), className: c.className, nonEditable: editable });
      } else if( type == 'viewInt' ) {
        let text = (data[c.id] == undefined) ? '' : Utils.viewInt(data[c.id]);
        rowBody.cells.push({ type: 'text', text: text, value: text, className: c.className, nonEditable: editable });
      }  else if( type == 'viewPer' ) {
        let text = (data[c.id] == undefined) ? '' : parseFloat(data[c.id]) +'%';
        rowBody.cells.push({ type: 'text', text: text, value: text, className: c.className, nonEditable: editable });
      } else {
        let text = (data[c.id] == undefined) ? '' : data[c.id];
        rowBody.cells.push({ type: type, text: String(text), value: String(text), className: c.className, nonEditable: editable });
      }
    });
    
    return rowBody;
  }
  // -------------------------------------------------------
  
  change(updateArray) {
    let rows = this.state.rows;
    rows = rows.map((d) => {
      d.cells = d.cells.map((c) => {
        if( c.type == 'dropdown' ) c.isOpen = false;
        return c;
      });
      return d;
    });
    
    updateArray.map((upd) => {
      let set_column = null;
      this.state.columns.map((c, key) => { if( c.columnId == upd.columnId ) set_column = key; });
      
      rows = rows.map((d, key) => {
        if( d.rowId == upd.rowId ){
          d.cells[set_column] = upd.newCell;
        }
        return d;
      });
    });
    
    this.setState({ rows: rows, is_loading: true });
    setTimeout( function(){ this.setState({ is_loading: false }); }.bind(this), 1);
    
    this.updateGridData.bind(this)(rows, this.state.columns);
  }
  // -------------------------------------------------------
  
  updateGridData(rows, columns) {
    if( this.props.update_ev == undefined ) return;
    
    let resultRows = [];
    rows.map((d) => {
      if( d.rowId == 'excel_row' || d.rowId == 'header_parent' || d.rowId == 'header' ) return;
      
      let row_data = {};
      d.cells.map((row, rowkey) => {
        if( rowkey == 0 ) return;
        columns.map((c, ckey) => { if( ckey == rowkey && row.text != '' ) row_data[c.columnId] = row.text; });
      });
      
      if( Object.keys(row_data).length > 0 ) resultRows.push(Object.assign({ rowId: d.rowId }, row_data));
    });
    
    this.props.update_ev.bind(this)(resultRows, columns);
  }
  // -------------------------------------------------------
  
  resize(id, width) {
    let columns = this.state.columns.map((d) => {
      if( d.columnId == id ) d.width = width;
      return d;
    });
    this.setState({ columns: columns });
  }
  // -------------------------------------------------------
  
  focus(obj) {
    let result = {};
    
    this.state.rows.map((d) => {
      if( d.rowId == obj.rowId ){
        d.cells.map((c, key) => {
          this.state.columns.map((co, ckey) => {
            if( key == ckey ) result[co.columnId] = c.text;
          });
        });
      }
    });
    
    if( this.props.focus_ev != undefined ) this.props.focus_ev.bind(this)(result);
  }
  // -------------------------------------------------------
  
  add() {
    let rows = this.state.rows;
    
    let rowBody = { rowId: (rows.length), cells: [{ type: 'header', text: String(rows.length), className: 'main-left' }] };
    this.props.columns.map((c, ckey) => {
      let type = (c.type == undefined) ? 'text' : c.type;
      if( type == 'dropdown' ){
        let values = [];
        c.values.map((v, vkey) => { values.push({ label: v, value: v }) });
        
        rowBody.cells.push({ type: type, text: '', selectedValue: '', values: values });
      } else {
        rowBody.cells.push({ type: type, text: '', value: '' });
      }
    });
    
    rows.push(rowBody);
    this.setState({ rows: rows });
  }
  // -------------------------------------------------------
  
  setRowData() {
    let must_columns     = this.props.must_columns;
    let error_columns    = this.props.error_columns;
    let disable_columns  = this.props.disable_columns;
    let emphasis_columns = this.props.emphasis_columns;
    let auto_set_columns = this.props.auto_set_columns;
    
    if( must_columns     == undefined ) must_columns    = [];
    if( error_columns    == undefined ) error_columns   = [];
    if( disable_columns  == undefined ) disable_columns = [];
    if( emphasis_columns == undefined ) emphasis_columns = [];
    if( auto_set_columns == undefined ) auto_set_columns = [];
    
    // カラム設定
    let head_columns = 0;
    let rows = this.state.rows.map((d, raw_key) => {
      if( d.rowId == 'excel_row' || d.rowId == 'header_parent' || d.rowId == 'header' ){
        head_columns++;
        return d;
      }
      
      // フィールドごとにデザインを適用
      d.cells = d.cells.map((c, ckey) => {
        if( c.className != undefined ) c.className = c.className.replace('must-field', '');
        if( c.className != undefined ) c.className = c.className.replace('error-field', '');
        if( c.className != undefined ) c.className = c.className.replace('disable-field', '');
        if( c.className != undefined ) c.className = c.className.replace('emphasis-field', '');
        
        must_columns.map((column) => {
          try { if( this.state.columns[ckey].columnId == column ) c.className += ' must-field'; } catch(e) {}
        });
        error_columns.map((e) => {
          try { if( e.rowId == d.rowId && this.state.columns[ckey].columnId == e.column ) c.className += ' error-field'; } catch(e) {}
        });
        disable_columns.map((column) => {
          try { if( this.state.columns[ckey].columnId == column ) c.className += ' disable-field'; } catch(e) {}
        });
        emphasis_columns.map((e) => {
          try { if( e.rowId == d.rowId && this.state.columns[ckey].columnId == e.column && auto_set_columns.indexOf(e.column) == -1 ) c.className += ' emphasis-field'; } catch(e) {}
        });
        
        // カンマ区切り対応
        this.state.columns.map((co, co_key) => {
          if( ckey == co_key && co.type == 'viewInt' && c.text != '' && c.text != undefined ){
            c.text  = Utils.viewInt(c.text);
            c.value = Utils.viewInt(c.value);
          }
          if( ckey == co_key && co.type == 'viewPer' && c.text != '' && c.text != undefined ){
            c.text  = parseFloat(c.text) +'%';
            c.value = parseFloat(c.value) +'%';
          }
        });
        
        return c;
      });
      
      // 自動設定項目の適用
      try {
        d.cells = d.cells.map((c, ckey) => {
          this.state.columns.map((co, co_key) => {
            if( ckey != co_key || auto_set_columns.indexOf(co.columnId) == -1 ) return;
            
            try {
              let set_value = this.props.items[(raw_key - head_columns)][co.columnId];
              if( set_value == undefined ) return;
              
              c.text  = set_value;
              c.value = set_value;
            } catch(e) {}
          });
          
          return c;
        });
      } catch(e) {}
      
      return d;
    });
    
    return rows;
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let base = this.props.base;
    
    //if( this.state.is_loading === true ) return <div className="grid is-loading" />;
    
    return (
      <div className="grid">
        <ReactGrid
          rows={this.setRowData.bind(this)()}
          columns={this.state.columns}
          onCellsChanged={this.change.bind(this)}
          onFocusLocationChanged={this.focus.bind(this)}
          onContextMenu={simpleHandleContextMenu}
          onColumnResized={this.resize.bind(this)}
          enableRowSelection
          enableFillHandle
          enableRangeSelection
          enableGroupIdRender
		      stickyLeftColumns={this.props.stickyLeftColumns}
		      stickyTopRows={this.props.stickyTopRows}
		      initialFocusLocation={this.props.initialFocusLocation}
        />
        
        { (this.props.add_button !== false ) && <div className="add" onClick={this.add.bind(this)}>+</div> }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Grid;